import { cx } from '@flowus/common/cx';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';

interface ExpandNodeProps {
  level: number;
  expand: boolean;
  onExpand: (expand: boolean) => void;
  className?: string;
}
export const ExpandNode: FC<ExpandNodeProps> = (props) => {
  const { expand, level, onExpand } = props;
  return (
    <Icon
      data-disable-select
      className={cx('animate-hover', props.className)}
      style={{
        marginLeft: level * 20,
      }}
      name={expand ? 'IcToggleBlackUnfold' : 'IcToggleBlack'}
      size="xlarge"
      onClick={(e) => {
        e.stopPropagation();
        onExpand(!expand);
      }}
    />
  );
};
